import React, { useState, useEffect } from "react";
import JsxUIManager from "../../../../UI/JsxUiManager";

export const SingleUI = (props: SingleUIProps) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	useEffect(() => {
		if(!(window as any)[props.id]) {
			(window as any)[props.id] = {};
		}
		(window as any)[props.id]['main'] = () => {
			setForceUpdate(!forceUpdate);
		}
	})
	return (
		<div style={{
			position: 'absolute',
			pointerEvents: 'none',
			width: '100%',
			height: '100%',
			left: '0',
			top: '0'
		}}>
			{props.uiManager._uis.map((ui: any, uiIndx: number) => {
				if(ui.name !== props.id) {
					return null;
				}

				return ui.instances.map((instance: any, uiInstanceIndx: number) => {
					return <SingleUIInstance parentInstanceId={props.id} ui={ui} instance={instance}></SingleUIInstance>
				})
			})}
		</div>
	)
};


export interface SingleUIProps {
	id: string;
	uiManager: JsxUIManager;
}

export interface SingleUIInstanceProps {
	parentInstanceId: string;
	instance: any;
	ui: any;
}

export const SingleUIInstance = (props: SingleUIInstanceProps) => {
	const [updateCounter, setUpdateCounter] = useState(0);
	useEffect(() => {
		(window as any)[props.parentInstanceId][props.instance.id] = () => {
			setUpdateCounter(updateCounter+1);
		}
	})
	return (
		<div style={{
			position: 'absolute',
			pointerEvents: 'none',
			width: '100%',
			height: '100%',
			left: '0',
			top: '0',
			overflow: 'hidden'
		}}>
			{props.ui.uiData.renderMethod(props.instance)}
		</div>
	)
};